import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  commodityData: [],
  backAuth: []
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_COMMODITY](state, data) {
    state.commodityData = data
  },
  [types.SET_BACKAUTH](state, data) {
    state.backAuth = data
  }
}
// getters
const getters = {
  getCommodity: state => index => {
    return state.commodityData
  },
  getBackAuth: state => index => {
    return state.backAuth
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
